/**
 * URL 参数管理工具
 * 用于捕获、存储和替换 affiliate 链接中的 URL 参数
 */

const STORAGE_KEY = 'affiliate_url_params';

/**
 * URL 参数映射关系
 * key: URL 参数名
 * value: affiliate 链接中的占位符名
 */
const PARAM_MAPPING = {
  utm_term: 'keyword',
  gclid: 'gclid',
  utm_creative: 'creative',
  utm_campaign: 'campaignid'
};

/**
 * 从 URL 中捕获指定的参数并存储到 localStorage
 * 只在首次访问或参数发生变化时更新
 */
export const captureUrlParams = () => {
  try {
    // 获取当前 URL 的查询参数
    const urlParams = new URLSearchParams(window.location.search);
    const params = {};
    let hasParams = false;

    // 遍历需要捕获的参数
    Object.keys(PARAM_MAPPING).forEach(paramName => {
      const value = urlParams.get(paramName);
      if (value) {
        params[paramName] = value;
        hasParams = true;
      }
    });

    // 如果有参数，则存储到 localStorage
    if (hasParams) {
      const existingParams = getStoredParams();
      const mergedParams = { ...existingParams, ...params };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(mergedParams));
      console.log('[URL Params] Captured and stored:', mergedParams);
      return mergedParams;
    }

    return getStoredParams();
  } catch (error) {
    console.error('[URL Params] Error capturing params:', error);
    return {};
  }
};

/**
 * 从 localStorage 获取已存储的参数
 * @returns {Object} 存储的参数对象
 */
export const getStoredParams = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch (error) {
    console.error('[URL Params] Error reading stored params:', error);
    return {};
  }
};

/**
 * 清除存储的参数（用于测试或重置）
 */
export const clearStoredParams = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
    console.log('[URL Params] Cleared stored params');
  } catch (error) {
    console.error('[URL Params] Error clearing params:', error);
  }
};

/**
 * 替换 affiliate 链接中的占位符
 * @param {string} link - 原始的 affiliate 链接
 * @returns {string} 替换后的链接
 */
export const replaceAffiliateLink = (link) => {
  if (!link || typeof link !== 'string') {
    return link;
  }

  try {
    const storedParams = getStoredParams();
    let replacedLink = link;

    console.log('[URL Params] Replacing link:', link);
    console.log('[URL Params] Stored params:', storedParams);

    // 遍历参数映射，替换占位符
    Object.entries(PARAM_MAPPING).forEach(([urlParam, placeholder]) => {
      const value = storedParams[urlParam] || '';
      const placeholderPattern = new RegExp(`\\{${placeholder}\\}`, 'g');
      replacedLink = replacedLink.replace(placeholderPattern, value);
    });

    console.log('[URL Params] Replaced link:', replacedLink);
    return replacedLink;
  } catch (error) {
    console.error('[URL Params] Error replacing affiliate link:', error);
    return link;
  }
};

/**
 * 获取参数映射关系（用于调试）
 */
export const getParamMapping = () => {
  return { ...PARAM_MAPPING };
};

